module.exports = __webpack_public_path__ + "img/double_golden.f0d38de6.svg";